import { accountsApi } from "./client"
import type { PaginatedResponse, Site } from "@/types/api"

export async function fetchSites(): Promise<Site[]> {
  const response = await accountsApi
    .get("api/sites/", { searchParams: { page_size: 5000 } })
    .json<PaginatedResponse<Site>>()
  return response.results
}
